import Expander from './Expander'
import styles from './ItemsExpander.module.scss'

import React, { useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'

import ClassNames from 'classnames'

import LayerColorFinder from 'Utilities/LayerColorFinder'

const ItemsExpander = ({
  items,
  closedHeight,
  layer,
  handleCallback,
  showGradient,
  testid,
  numDesktopColumns = 4,
  numMobileColumns = 2,
}) => {
  const [leftEdgeRef, leftEdgeInView] = useInView({ initialInView: true })
  const [rightEdgeRef, rightEdgeInView] = useInView()
  const scrollRef = useRef(null)
  const gradientColor = LayerColorFinder(layer || 0)
  const gradientInlineStyle = showGradient
    ? {
        backgroundImage: `linear-gradient(to right, ${gradientColor}, transparent)`,
      }
    : null
  const leftGradientStyles = ClassNames(
    leftEdgeInView ? styles.hide : null,
    showGradient ? styles.mobileGradient : null,
    showGradient ? styles.mobileGradientLeft : null,
  )
  const rightGradientStyles = ClassNames(
    rightEdgeInView ? styles.hide : null,
    showGradient ? styles.mobileGradient : null,
    showGradient ? styles.mobileGradientLeft : null,
  )

  useEffect(() => {
    try {
      if (scrollRef?.current) {
        scrollRef.current.scrollLeft = 0
      }
    } catch (err) {
      console.error(err)
    }
  }, [items?.length])

  const children = (
    <div className={styles.wrapper}>
      <span style={gradientInlineStyle} className={leftGradientStyles}></span>
      <div
        ref={scrollRef}
        className={ClassNames(
          styles.itemsWrapper,
          styles[`desktop-cols-${numDesktopColumns}`],
          styles[`mobile-cols-${numMobileColumns}`],
        )}
      >
        <div key={'leftEdgeRef'} ref={leftEdgeRef} className={styles.leftGradientRef}></div>
        {items.map((item, i) => {
          return (
            <div className={styles.item} key={`top_category_${i}`}>
              {item}
            </div>
          )
        })}
        <div key={'rightEdgeRef'} ref={rightEdgeRef} className={styles.rightGradientRef}></div>
      </div>
      <span style={gradientInlineStyle} className={rightGradientStyles}></span>
    </div>
  )
  return (
    <Expander
      testid={testid}
      closedHeight={closedHeight}
      count={items.length}
      mobileHorizontalScroll
      expanderCallback={handleCallback}
    >
      {children}
    </Expander>
  )
}

export default ItemsExpander
